// Cart Auto-Add
(() => {
    const originalLog = console.log;
    const state = { isRefreshing: false, hasAutoRefreshed: false };
    let refreshTimeout;
  
    console.log = (...args) => {
      const message = args.join(' ');
      if (message.includes('Cart Updated Detected') && !state.isRefreshing) {
        clearTimeout(refreshTimeout);
        refreshTimeout = setTimeout(() => 
          document.dispatchEvent(new CustomEvent('cart:refresh')), 1200
        );
      } else {
        originalLog(...args);
      }
    };
  
    document.addEventListener('cart:refresh', () => {
      if (state.isRefreshing) return;
      state.isRefreshing = true;
  
      theme.cart.getCart().then(cart => {
        if (cart.item_count === 0) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:build'));
          setTimeout(() => state.isRefreshing = false, 1000);
        }
      });
    });
  
    document.addEventListener('abra:cart:changed', () => 
      document.dispatchEvent(new CustomEvent('cart:refresh'))
    );

    document.addEventListener('click', (e) => {
      if (e.target.closest('.abra-banner__discount-variant-add')) {
        setTimeout(() => 
          document.dispatchEvent(new CustomEvent('cart:refresh')), 1500
        );
      }
    });

    const initAutoRefresh = () => {
      if (window.location.pathname === '/cart' && !state.hasAutoRefreshed) {
        state.hasAutoRefreshed = true;
        setTimeout(() => 
          document.dispatchEvent(new CustomEvent('cart:build')), 1500
        );
      }
    };
  
    document.readyState === 'loading' 
      ? document.addEventListener('DOMContentLoaded', initAutoRefresh)
      : initAutoRefresh();
  })();

//  Abra Banner next and previous btn fix
(() => {
  const bannerState = new WeakMap();

  function getBannerState(banner, total) {
    if (!bannerState.has(banner)) {
      const countEl = banner.querySelector('.abra-banner__paginator-count');
      const match = countEl?.textContent?.match(/(\d+)\/(\d+)/);
      const current = match ? parseInt(match[1], 10) : 1;
      bannerState.set(banner, { current });
    }
    return bannerState.get(banner);
  }

  function updatePaginatorCounter(banner, current, total) {
    const countEl = banner.querySelector('.abra-banner__paginator-count');
    const prevBtn = banner.querySelector('.abra-banner__paginator-prev');
    const nextBtn = banner.querySelector('.abra-banner__paginator-next');
    if (countEl) countEl.textContent = `${current}/${total}`;
    const prevShouldBeDisabled = current <= 1;
    const nextShouldBeDisabled = current >= total;
    if (prevBtn && prevBtn.disabled !== prevShouldBeDisabled) prevBtn.disabled = prevShouldBeDisabled;
    if (nextBtn && nextBtn.disabled !== nextShouldBeDisabled) nextBtn.disabled = nextShouldBeDisabled;
  }

  function scrollBannerOneCard(button, direction) {
    const banner = button.closest('.abra-banner') || button.closest('abra-banner');
    if (!banner) return;
    const scrollEl = banner.querySelector('.abra-banner__discounts-scroll');
    const cards = scrollEl?.querySelectorAll('.abra-banner__discount');
    if (!scrollEl || !cards?.length) return;

    const total = cards.length;
    const state = getBannerState(banner, total);
    const isNext = direction === 'next';
    const newCurrent = isNext
      ? Math.min(state.current + 1, total)
      : Math.max(state.current - 1, 1);
    if (newCurrent === state.current) return;

    state.current = newCurrent;
    const targetCard = cards[state.current - 1];
    if (targetCard) {
      targetCard.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    updatePaginatorCounter(banner, state.current, total);
    requestAnimationFrame(() => updatePaginatorCounter(banner, state.current, total));
    setTimeout(() => updatePaginatorCounter(banner, state.current, total), 150);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.abra-banner__paginator-button');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const isNext = btn.classList.contains('abra-banner__paginator-next');
    const isPrev = btn.classList.contains('abra-banner__paginator-prev');
    if (!isNext && !isPrev) return;

    scrollBannerOneCard(btn, isNext ? 'next' : 'prev');
  }, true);

  document.addEventListener('mousedown', (e) => {
    if (e.target.closest('.abra-banner__paginator-button')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  const observer = new MutationObserver((mutations) => {
    const bannersToFix = new Set();
    for (const m of mutations) {
      const el = m.target;
      if (!el?.classList?.contains?.('abra-banner__paginator-button')) continue;
      const banner = el.closest('.abra-banner') || el.closest('abra-banner');
      if (banner) bannersToFix.add(banner);
    }
    bannersToFix.forEach((banner) => {
      const scrollEl = banner.querySelector('.abra-banner__discounts-scroll');
      const cards = scrollEl?.querySelectorAll('.abra-banner__discount');
      if (!cards?.length) return;
      const total = cards.length;
      const state = getBannerState(banner, total);
      updatePaginatorCounter(banner, state.current, total);
    });
  });
  observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
})();